<template>
  <div>
    <Header :title="title" :showBack="true" v-if="!isFromTicketChange"></Header>

    <div class="LineClassDaySale">
      <!-- 上车点 -->
      <div class="Node" id="startNode" v-if="isShowStart">
        <p class="title">请选择上车点</p>
        <van-search
          v-if="IsShowLineClassDaySaleSearch"
          v-model="searchStartNode"
          placeholder="站点名搜索"
        />
        <div class="list">
          <ul>
            <li
              v-for="(item, index) of startNodeList"
              :key="item.id"
              @click="startNodeClick(item, index)"
              :class="{ current: item.selectState }"
              style="font-size: 20px"
            >
              {{ item.NodeName }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 下车点 -->
      <div class="Node" id="arrivalNode" v-if="isShowEnd">
        <p class="title">请选择下车点</p>
        <van-search
          v-if="IsShowLineClassDaySaleSearch"
          v-model="searchArrivalNode"
          placeholder="站点名搜索"
        />
        <div class="list">
          <ul>
            <li
              v-for="(item, index) of arrivalNodeList"
              :key="item.id"
              @click="arrivalNodeClick(item, index)"
              :class="{ current: item.selectState }"
              style="font-size: 20px"
            >
              {{ item.NodeName }}
            </li>
          </ul>
        </div>
      </div>

      <div class="btn" v-on:click="btnClick" :class="{ current: isSelected }">
        选好了
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "班线售票", //标题
      LineGID: this.$route.params.selectLineGID, // 线路GID
      isShowStart: false,
      isShowEnd: false,
      startNodeList: [], // 上车点
      orgStartNodeList: [], // 上车点
      startprovinceNode: [], // 省站上车站点
      arrivalNodeList: [], // 下车点
      orgArrivalNodeList: [], // 下车点
      isSelected: false, // 是否已经选中下车站点
      startSelectedCityCode: "", // 上车点城市GID
      startSelectedGID: "", // 上车点GID
      startSelectedName: "", // 上车点名称
      arrivalSelectedCityCode: "", // 下车点城市GID
      arrivalSelectedGID: "", // 下车点GID
      arrivalSelectedName: "", // 下车点名称
      isFromTicketChange: false, // 是否来自换乘页面
      saleQueryPagePath: "LineClassDaySaleQuery",
      searchStartNode: "",
      searchArrivalNode: "",
      IsShowLineClassDaySaleSearch: false, //手持机班线售票是否显示搜索功能
    };
  },
  watch: {
    searchStartNode(v) {
      debugger;
      this.startNodeList = [];
      if (!v) {
        this.startNodeList = this.orgStartNodeList;
      }
      this.orgStartNodeList.forEach((element) => {
        if (element.NodeName.indexOf(v) >= 0) {
          let needAdd = true;
          if (this.startNodeList.length == 0) {
            needAdd = true;
          } else {
            this.startNodeList.forEach((item) => {
              if (item.GID == element.GID) {
                needAdd = false;
              }
            });
          }
          if (needAdd) {
            this.startNodeList.push(element);
          }
        }
      });
    },
    searchArrivalNode(v) {
      debugger;
      this.arrivalNodeList = [];
      if (!v) {
        this.arrivalNodeList = this.orgArrivalNodeList;
      }
      this.orgArrivalNodeList.forEach((element) => {
        if (element.NodeName.indexOf(v) >= 0) {
          let needAdd = true;
          if (this.arrivalNodeList.length == 0) {
            needAdd = true;
          } else {
            this.arrivalNodeList.forEach((item) => {
              if (item.GID == element.GID) {
                needAdd = false;
              }
            });
          }
          if (needAdd) {
            this.arrivalNodeList.push(element);
          }
        }
      });
    },
  },

  methods: {
    //上车点选择
    startNodeClick(item, index) {
      var List = JSON.parse(JSON.stringify(this.startNodeList));
      List.forEach((item) => {
        this.$set(item, "selectState", false);
      });
      List[index].selectState = true;
      this.startNodeList = [];
      this.startNodeList = List;
      this.startSelectedCityCode = item.CityCode;
      this.startSelectedGID = item.NodeGID;
      this.startSelectedName = item.NodeName;
      this.isShowStart = false;
      this.isShowEnd = true;
    },
    // 获取上车点
    getLineClassStartNode() {
      if (window.sessionStorage) {
        if (!this.LineGID) {
          this.LineGID = window.sessionStorage.getItem("LineGID");
        }
      }
      let params = {
        LineGID: this.LineGID,
      };
      this.$http
        .post(this.$api.getLineClassStartNode, this.$qs.stringify(params))
        .then((res) => {
          this.orgStartNodeList = res.data;
          this.startNodeList = res.data;
          if (this.startNodeList.length > 0) {
            //如果是省汽车站 上车点固定省站
            if (
              JSON.parse(
                window.localStorage.getItem("adminInfo")
              ).CompGID.toUpperCase() == "F3B32D79-D331-4FF0-A813-A6DF403C0DB8"
            ) {
              this.startprovinceNode = this.startNodeList.filter((item) => {
                return item.NodeGID == "1576bf32-224b-4aad-acb1-5ee72d4fa5b6";
              });
              if (this.startprovinceNode.length == 1) {
                this.startSelectedCityCode = this.startprovinceNode[0].CityCode;
                this.startSelectedGID = this.startprovinceNode[0].NodeGID;
                this.startSelectedName = this.startprovinceNode[0].NodeName;
                this.isShowEnd = true;
              } else {
                //其它公司暂不开放
                this.$toast("该线路暂无省汽车站站点");
                this.$router.push("/");
                return;
              }
            } else if (
              JSON.parse(
                window.localStorage.getItem("adminInfo")
              ).CompGID.toUpperCase() == "44691315-8E52-4235-B597-AE6B06FB5589"
            ) {
              //如果是罗冲围汽车站 上车点固定罗冲围
              this.startprovinceNode = this.startNodeList.filter((item) => {
                return (
                  item.NodeGID.toUpperCase() ==
                  "9F7DB641-34C1-4E44-9136-00B16C201CED"
                );
              });
              if (this.startprovinceNode.length == 1) {
                this.startSelectedCityCode = this.startprovinceNode[0].CityCode;
                this.startSelectedGID = this.startprovinceNode[0].NodeGID;
                this.startSelectedName = this.startprovinceNode[0].NodeName;
                this.isShowEnd = true;
              } else {
                //其它公司暂不开放
                this.$toast("该线路暂无罗冲围汽车站站点");
                this.$router.push("/");
                return;
              }
            } else {
              //如果参数开启 允许使用购票功能
              if (this.$utils.getSysParams("IsHandhelShowClassSale") === "1") {
                this.isShowStart = true;
              } else {
                //其它公司暂不开放
                this.$toast("暂未开放此功能 请联系管理员");
                this.$router.push("/");
                return;
              }
            }
            this.getLineClassArrivalNode();
          }
        });
    },
    // 获取下车点
    getLineClassArrivalNode() {
      let params = {
        LineGID: this.LineGID,
      };
      this.$http
        .post(this.$api.getLineClassArrivalNode, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.orgArrivalNodeList = res.data;
            this.arrivalNodeList = res.data;
            this.arrivalNodeList.forEach((item, index) => {
              if (item == "（Y）" || item == "（L）") {
                this.arrivalNodeList.splice(index);
              }
            });
          }
        });
    },
    // 下车站点选择
    arrivalNodeClick(item, index) {
      var List = JSON.parse(JSON.stringify(this.arrivalNodeList));
      List.forEach((item) => {
        this.$set(item, "selectState", false);
      });
      List[index].selectState = true;
      this.arrivalNodeList = [];
      this.arrivalNodeList = List;

      // 选择下车站点后 使按钮为可点击
      this.isSelected = true;

      this.arrivalSelectedCityCode = item.CityCode;
      this.arrivalSelectedGID = item.NodeGID;
      this.arrivalSelectedName = item.NodeName;
    },
    btnClick() {
      if (!window.sessionStorage) {
        this.$toast("该环境不支持本地存储");
      } else {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(
            "StartCityCode",
            this.startSelectedCityCode
          );
          window.sessionStorage.setItem("StartNodeGID", this.startSelectedGID);
          window.sessionStorage.setItem(
            "ArrivalCityCode",
            this.arrivalSelectedCityCode
          );
          window.sessionStorage.setItem(
            "ArrivalNodeGID",
            this.arrivalSelectedGID
          );
          window.sessionStorage.setItem(
            "StartSelectedName",
            this.startSelectedName
          );
          window.sessionStorage.setItem(
            "ArrivalSelectedName",
            this.arrivalSelectedName
          );
        }
      }
      if (this.startSelectedGID && this.arrivalSelectedGID) {
        let routerParams = {
          // name: 'LineClassDaySaleQuery',
          path: this.saleQueryPagePath,
          params: {
            StartCityCode: this.startSelectedCityCode,
            ArrivalCityCode: this.arrivalSelectedCityCode,
            StartSelectedName: this.StartSelectedName,
            StartNodeGID: this.startSelectedGID,
            ArrivalNodeGID: this.arrivalSelectedGID,
            ArrivalSelectedName: this.ArrivalSelectedName,
          },
        };
        // 嵌套在换乘页面不需要留下记录
        if (this.isFromTicketChange) {
          this.$router.replace(routerParams);
        } else {
          this.$router.push(routerParams);
        }
      } else {
        this.$toast("没有获取到上下车站点数据");
      }
    },
  },
  mounted() {
    debugger;
    //手持机班线售票是否显示搜索功能
    if (this.$utils.getSysParams("IsShowLineClassDaySaleSearch") == "1") {
      this.IsShowLineClassDaySaleSearch = true;
    }

    this.getLineClassStartNode();
  },
  created() {
    if (this.$route.path == "/TicketChange/LineClassDaySale") {
      this.isFromTicketChange = true;
      this.saleQueryPagePath = "/TicketChange/LineClassDaySaleQuery";
    }
  },
};
</script>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}

.LineClassDaySale {
  width: 100%;
  height: auto;
  overflow: hidden;

  .Node {
    width: 100%;
    height: auto;

    .title {
      width: 100%;
      height: 1.4rem;
      line-height: 1.4rem;
      font-size: 0.5rem;
      text-align: center;
      box-sizing: border-box;
      color: #333;
      border-bottom: 1px solid #eee;
    }

    .list {
      width: 100%;
      height: calc(100vh - 3.8375rem);
      overflow-y: scroll;

      ul {
        width: 100%;
        height: auto;
        padding: 0 0.2rem;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(3, 33.33%);
        grid-template-rows: repeat(0);

        li {
          width: 100%;
          height: 2rem;
          line-height: 2rem;
          background: #fff;
          border: 2px solid #eee;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 0.2rem;
          box-sizing: border-box;
        }

        li.current {
          background: #ffb870;
          color: #fff;
        }
      }
    }
  }

  .btn {
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.44rem;
    color: #fff;
    background-color: #ccc;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .btn.current {
    color: #fff;
    background-color: orange;
  }
}

.LineClassDaySale > .Node:first-child > .list > ul > li.current {
  color: #fff;
  background-color: orange;
}

.LineClassDaySale > .Node:nth-child(2) > .list > ul > li.current {
  color: #fff;
  background-color: orange;
}
</style>
